import axios from 'axios';
import { ApiResponseType } from '../../types/types';
import {
  GetStakingHubUlxWithdrawalInfoResponse,
  ChangeAutoStakeForPackageResponse,
  GetMyHubsSummaryResponse,
  GetMyHubsTradingResponse,
  GetMyHubsPaymentResponse,
  GetMyHubsGamingResponse,
  GetMyHubsStakingResponse,
  GetConversionInfoResponse,
  GetMyHubsBigWhaleResponse,
  AddBigWhaleVoucherResponse,
  WillyCoinsSummaryResponse
} from './Portfolio.types';
import { confirmNFTWithdrawRequest } from './WithdrawHubs/types';

export const getMyHubsSummaryAsync = async (): Promise<
  ApiResponseType<GetMyHubsSummaryResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsSummaryResponse>>(
    `/my-hubs/summary`
  );
  return data;
};

export const getMyHubsTradingAsync = async (): Promise<
  ApiResponseType<GetMyHubsTradingResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsTradingResponse>>(
    `/my-hubs/trading`
  );
  return data;
};

export const getMyHubsPowerPackAsync = async (): Promise<
  ApiResponseType<GetMyHubsPaymentResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsPaymentResponse>>(
    `my-hubs/power-pack`
  );

  return data;
};

export const getMyHubsAkashaAsync = async (): Promise<
  ApiResponseType<GetMyHubsPaymentResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsPaymentResponse>>(
    `my-hubs/akasha`
  );

  return data;
};

export const getMyHubsTravelAsync = async (): Promise<
  ApiResponseType<GetMyHubsBigWhaleResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsBigWhaleResponse>>(
    `/my-hubs/revolution`
  );

  return data;
};

export const getMyHubsBigWhaleAsync = async (): Promise<
  ApiResponseType<GetMyHubsBigWhaleResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsBigWhaleResponse>>(
    `/my-hubs/big-whale`
  );
  return data;
};

export const getMyHubsPaymentAsync = async (): Promise<
  ApiResponseType<GetMyHubsPaymentResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsPaymentResponse>>(
    `/my-hubs/payment`
  );

  return data;
};
export const getFlipMeCardsAsync = async (): Promise<
  ApiResponseType<GetMyHubsPaymentResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsPaymentResponse>>(
    `/my-hubs/flip-me`
  );

  return data;
};

export const getMyHubsGamingAsync = async (): Promise<
  ApiResponseType<GetMyHubsGamingResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsGamingResponse>>(
    `/my-hubs/gaming`
  );
  return data;
};

export const getMyHubsStakingAsync = async (): Promise<
  ApiResponseType<GetMyHubsStakingResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyHubsStakingResponse>>(
    `/my-hubs/staking`
  );
  return data;
};

export const getConversionInfoAsync = async (
  userPackageId: number
): Promise<ApiResponseType<GetConversionInfoResponse>> => {
  const { data } = await axios.get<ApiResponseType<GetConversionInfoResponse>>(
    `/package/convert-to-lp/${userPackageId}`
  );
  return data;
};

export const convertHubToLPAsync = async (
  userPackageId: number
): Promise<ApiResponseType<null>> => {
  const { data } = await axios.post<ApiResponseType<null>>(
    `/package/convert-to-lp`,
    { userPackageId }
  );
  return data;
};

export const changeAutoStakeAsync = async (
  userPackageId: number,
  newStatus: boolean
): Promise<ApiResponseType<ChangeAutoStakeForPackageResponse>> => {
  const { data } = await axios.put<
    ApiResponseType<ChangeAutoStakeForPackageResponse>
  >(`/package/autostake/change`, {
    userPackageId,
    newStatus
  });

  return data;
};

export const changeBonusHubAutoStakeAsync = async (newStatus: boolean) => {
  const { data } = await axios.put(`/package/staking/bonus/autostake`, {
    newStatus
  });

  return data;
};

export const getStakingWithdrawalInfoAsync = async (
  userPackageId: number,
  amount: string
): Promise<ApiResponseType<GetStakingHubUlxWithdrawalInfoResponse>> => {
  const { data } = await axios.get<
    ApiResponseType<GetStakingHubUlxWithdrawalInfoResponse>
  >(`/package/staking-withdraw-info`, {
    params: { userPackageId, amount }
  });

  return data;
};

export const getBonusHubWithdrawalInfoAsync = async (amount: string) => {
  const { data } = await axios.get(`/package/staking/bonus/withdraw`, {
    params: { amount }
  });

  return data;
};

export const burnULXAsync = async (userPackageId: number, amount: string) => {
  return await axios.post<ApiResponseType<undefined>>(
    `/package/staking-withdraw`,
    {
      userPackageId,
      amount
    }
  );
};

export const burnBonusHubULXAsync = async (amount: string) => {
  return await axios.post<ApiResponseType<undefined>>(
    `/package/staking/bonus/withdraw`,
    {
      amount
    }
  );
};

export const claimGamingRewardsAsync = async () => {
  return await axios.post<ApiResponseType<undefined>>(
    `/explorer/gaming-usdt/claim`
  );
};

export const confirmNFTWithdrawAsync = async ({
  userPackageId,
  walletAddress,
  walletAddressSign,
  emailCode,
  twoFACode
}: confirmNFTWithdrawRequest): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/explorer/nft-withdraw/confirm`,
    {
      userPackageId,
      walletAddress,
      walletAddressSign,
      emailCode,
      twoFACode
    }
  );

  return data;
};

export const confirmBonusHubNFTWithdrawAsync = async ({
  walletAddress,
  walletAddressSign,
  emailCode,
  twoFACode
}: confirmNFTWithdrawRequest): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/explorer/bonus-nft-withdraw/confirm`,
    {
      walletAddress,
      walletAddressSign,
      emailCode,
      twoFACode
    }
  );

  return data;
};

export const purchaseBigWhaleVoucherAsync = async ({
  packageId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddBigWhaleVoucherResponse>> => {
  const { data } = await axios.post<
    ApiResponseType<AddBigWhaleVoucherResponse>
  >(`/package/meme-bonus-activation`, {
    userPackageId: packageId,
    networkType,
    lp,
    club,
    cash,
    usdt,
    usdc
  });

  return data;
};

export const getWiliCoinsSummaryAsync = async () => {
  const { data } = await axios.get(`/meme-coin/summary`);

  return data.data.summary as WillyCoinsSummaryResponse;
};
